<template>
  <svg width="16"
       height="16"
       viewBox="0 0 16 16"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#07455D" />
    <circle cx="8.0001" cy="4.42857" r="1.42857" :fill="color" />
    <circle cx="8.0001" cy="11.5716" r="1.42857" :fill="color" />
    <circle cx="8.0001" cy="7.99986" r="1.42857" :fill="color" />
    <ellipse
      cx="1.36282"
      cy="1.36119"
      rx="1.36282"
      ry="1.36119"
      transform="matrix(-0.499104 0.866542 -0.865507 -0.500897 13 9.31885)"
      :fill="color" />
    <ellipse
      cx="1.36282"
      cy="1.36119"
      rx="1.36282"
      ry="1.36119"
      transform="matrix(-0.499104 0.866542 -0.865507 -0.500897 6.7168 5.68262)"
      :fill="color" />
    <ellipse
      cx="1.36282"
      cy="1.36119"
      rx="1.36282"
      ry="1.36119"
      transform="matrix(-0.499103 -0.866542 0.865507 -0.500897 4.3606 11.6812)"
      :fill="color" />
    <ellipse
      cx="1.36282"
      cy="1.36119"
      rx="1.36282"
      ry="1.36119"
      transform="matrix(-0.499103 -0.866542 0.865507 -0.500897 10.6438 8.04443)"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    }
  }
}
</script>
